var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "operations" }, [
          _c("div", { staticClass: "triggers" }, [
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "new",
                      disabled: !_vm.isEdit || _vm.hasContractManage,
                      type: "primary"
                    },
                    on: {
                      click: function($event) {
                        return _vm.showEditDialog(true)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "edit",
                      disabled: !_vm.isEdit || _vm.hasContractManage,
                      type: "primary"
                    },
                    on: {
                      click: function($event) {
                        return _vm.showEditDialog(false)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "delete",
                      disabled: !_vm.isEdit || _vm.hasContractManage,
                      type: "danger"
                    },
                    on: { click: _vm.remove }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                ),
                _vm.$checkPermission(["button_enable_contract_limit"])
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          no: "toggleContractLimit",
                          disabled: !_vm.isEdit,
                          type: _vm.contractLimitEnabled ? "danger" : "primary"
                        },
                        on: { click: _vm.toggleContractLimit }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.contractLimitEnabled
                              ? _vm.$t("Partners.disableContractLimit")
                              : _vm.$t("Partners.enableContractLimit")
                          )
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.$checkPermission(["button_enable_contract_limit"]) &&
                _vm.contractLimitEnabled
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          no: "editReleaseDays",
                          disabled: !_vm.isEdit,
                          type: "primary"
                        },
                        on: { click: _vm.showEditReleaseDaysDialog }
                      },
                      [_vm._v(_vm._s(_vm.$t("Partners.editReleaseDays")))]
                    )
                  : _vm._e(),
                _vm.$checkPermission(["button_enable_contract_limit"]) &&
                _vm.contractLimitEnabled
                  ? _c(
                      "span",
                      { staticClass: "release-days-inline" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("Partners.availableReleaseDays")) +
                            "： "
                        ),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "right",
                              width: "400",
                              trigger: "hover",
                              "popper-class": "release-days-popover"
                            }
                          },
                          [
                            _c("div", { staticClass: "popover-content" }, [
                              _vm._v(
                                "未传合同：25天−客户创建日至当日间隔，负数计 0"
                              ),
                              _c("br"),
                              _vm._v(
                                "已传合同：取最晚合同失效日减当日，负数计 0"
                              ),
                              _c("br"),
                              _vm._v("系统自动计算，支持手动修改")
                            ]),
                            _c(
                              "span",
                              {
                                staticClass: "release-days-number",
                                attrs: { slot: "reference" },
                                slot: "reference"
                              },
                              [_vm._v(_vm._s(_vm.availableReleaseDays))]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c("br"),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasContractManage,
                        expression: "hasContractManage"
                      }
                    ],
                    staticStyle: { color: "red" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Partners.operateInMasterDataContractManagement")
                      )
                    )
                  ]
                )
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "grid-params": _vm.girdParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.girdParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.girdParams = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.effectiveDate") } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "beginDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.editDialog.form.beginDate,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "beginDate", $$v)
                          },
                          expression: "editDialog.form.beginDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.expiryDate") } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "endDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.editDialog.form.endDate,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "endDate", $$v)
                          },
                          expression: "editDialog.form.endDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FileNo") } },
                    [
                      _c("el-input", {
                        attrs: { no: "contractNo" },
                        model: {
                          value: _vm.editDialog.form.contractNo,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "contractNo", $$v)
                          },
                          expression: "editDialog.form.contractNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.remarks") } },
                    [
                      _c("el-input", {
                        attrs: { no: "remarks" },
                        model: {
                          value: _vm.editDialog.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remarks", $$v)
                          },
                          expression: "editDialog.form.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.saveSub }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("cargo-file-upload-dialog", {
        attrs: {
          visible: _vm.fileUpload.visible,
          title: _vm.fileUpload.title,
          "document-category": _vm.fileUpload.documentCategory,
          "business-id": _vm.fileUpload.businessId,
          "show-file-category": _vm.fileUpload.showFileCategory,
          lob: _vm.fileUpload.lob,
          parameters: _vm.fileUpload.parameters
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fileUpload, "visible", $event)
          },
          uploadDone: _vm.onUploadDone
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editReleaseDaysDialog.visible,
            title: _vm.$t("Partners.editReleaseDays"),
            width: "450px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editReleaseDaysDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "120px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("Partners.availableReleaseDays") }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "availableReleaseDays",
                          min: 0,
                          precision: 0,
                          "controls-position": "right"
                        },
                        on: { change: _vm.onReleaseDaysChange },
                        model: {
                          value:
                            _vm.editReleaseDaysDialog.form.availableReleaseDays,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editReleaseDaysDialog.form,
                              "availableReleaseDays",
                              $$v
                            )
                          },
                          expression:
                            "editReleaseDaysDialog.form.availableReleaseDays"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("Partners.releaseDeadlineDate") }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "releaseDeadlineDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { change: _vm.onReleaseDeadlineDateChange },
                        model: {
                          value:
                            _vm.editReleaseDaysDialog.form.releaseDeadlineDate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editReleaseDaysDialog.form,
                              "releaseDeadlineDate",
                              $$v
                            )
                          },
                          expression:
                            "editReleaseDaysDialog.form.releaseDeadlineDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.saveEditReleaseDays }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editReleaseDaysDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }